var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneybagCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.7815 9.33317L13.2191 9.33317L11.351 7.19045C9.51978 5.09001 11.6561 1.95047 14.3298 2.81297L15.5668 3.21203C15.8484 3.30288 16.1522 3.30288 16.4339 3.21203L17.6709 2.81297C20.3445 1.95047 22.4809 5.09001 20.6496 7.19045L18.7815 9.33317Z",
    fill: "#005DAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.57937 13.6138C8.62306 10.274 11.7161 8 15.2152 8H16.7855C20.2846 8 23.3776 10.274 24.4213 13.6138L26.088 18.9471C27.6978 24.0986 23.8493 29.3333 18.4522 29.3333H13.5485C8.15142 29.3333 4.30288 24.0986 5.91271 18.9471L7.57937 13.6138Z",
    fill: "#005DAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.6665C16 25.1937 17.1939 23.9998 18.6667 23.9998H26.6667C28.1394 23.9998 29.3333 25.1937 29.3333 26.6665C29.3333 28.1393 28.1394 29.3332 26.6667 29.3332H18.6667C17.1939 29.3332 16 28.1393 16 26.6665Z",
    fill: "#005DAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.3332C16 19.8604 17.1939 18.6665 18.6667 18.6665H25.7778H26.6667C28.1394 18.6665 29.3333 19.8604 29.3333 21.3332C29.3333 22.8059 28.1394 23.9998 26.6667 23.9998H18.6667C17.1939 23.9998 16 22.8059 16 21.3332Z",
    fill: "#005DAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneybagCoin);
export default __webpack_public_path__ + "static/media/money bag-coin.88536cbf48cd56ff1e3659442e4173cd.svg";
export { ForwardRef as ReactComponent };